export default [
    {
        path: '/heishop/target',
        name: 'heishop-target',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Target.vue')
    },

]